export const FAIL_ERROR_CODE_EXISTS = 'account_already_exists';
export const FAIL_ERROR_CODE_LOCKED = 'Account is locked';

export const FAIL_REASON_NOT_FOUND = 'FAIL_REASON_NOT_FOUND';
export const ENTITY_NOT_FOUND = 'entityNotFound';

export const FULL_SSN_VALIDATION = 'fullSsnValidation';
export const SHORT_SSN_VALIDATION = 'shortSsnValidation';
export const SSN_VALIDATION_BLOCKED = 'ssnValidationBlocked';

export const ACCOUNT_NOT_REGISTERED = 'accountNotRegistered';
export const ACCOUNT_ALREADY_EXISTS = 'accountAlreadyExists';
export const OTP_ACTIVITY_BLOCKED_UNTIL = 'otpActivityBlockedUntil';
export const FAIL_REASON_LOCKED = 'FAIL_REASON_LOCKED';
export const FAIL_REASON_ALREADY_EXISTS = 'FAIL_REASON_ALREADY_EXISTS';

export const ACTION_FORGOT_PASSWORD_RESET = 'AUTH/ACTION_FORGOT_PASSWORD_RESET';
export const ACTION_FORGOT_PASSWORD_CLEAR_FAILURE = 'AUTH/ACTION_FORGOT_PASSWORD_CLEAR_FAILURE';
export const ACTION_FORGOT_PASSWORD_REQUEST = 'AUTH/ACTION_FORGOT_PASSWORD_REQUEST';
export const ACTION_REGISTER_RESET = 'AUTH/ACTION_REGISTER_RESET';
export const ACTION_REGISTER_REQUEST = 'AUTH/ACTION_REGISTER_REQUEST';
export const ACTION_REGISTER_CLEAR_FAILURE = 'AUTH/ACTION_REGISTER_CLEAR_FAILURE';
export const ACTION_REMEMBER_ME_CHANGE = 'AUTH/ACTION_REMEMBER_ME_CHANGE';

export const ACTION_RESET_PASSWORD_RESET = 'AUTH/ACTION_RESET_PASSWORD_RESET';
export const ACTION_RESET_PASSWORD_REQUEST = 'AUTH/ACTION_RESET_PASSWORD_REQUEST';

export const CREATE_PASSWORD = 'AUTH/CREATE_PASSWORD';
export const CREATE_PASSWORD_RESET = 'AUTH/CREATE_PASSWORD_RESET';

export const SEND_OTP_TYPE = 'AUTH/SEND_OTP_TYPE';
export const ACTION_VERIFY_OTP = 'AUTH/ACTION_VERIFY_OTP';
export const OTP_RESET = 'AUTH/OTP_RESET';
export const OTP_TYPE_REGISTER_RESET = 'AUTH/OTP_TYPE_REGISTER_RESET';
export const OTP_FOCUS_AFTER_FAIL = 'AUTH/OTP_FOCUS_AFTER_FAIL';

export const FORGOT_PASSWORD_SEND_OTP_TYPE = 'AUTH/FORGOT_PASSWORD_SEND_OTP_TYPE';
export const FORGOT_PASSWORD_ACTION_VERIFY_OTP = 'AUTH/FORGOT_PASSWORD_ACTION_VERIFY_OTP';
export const FORGOT_PASSWORD_CREATE_PASSWORD = 'AUTH/FORGOT_PASSWORD_CREATE_PASSWORD';
export const FORGOT_PASSWORD_OTP_RESET = 'AUTH/FORGOT_PASSWORD_OTP_RESET';
export const FORGOT_PASSWORD_OTP_TYPE_RESET = 'AUTH/FORGOT_PASSWORD_OTP_TYPE_RESET';
export const FORGOT_PASSWORD_OTP_FOCUS_AFTER_FAIL = 'AUTH/FORGOT_PASSWORD_OTP_FOCUS_AFTER_FAIL';

export const VERIFY_EMAIL_BY_TOKEN = 'AUTH/VERIFY_EMAIL_BY_TOKEN';



// WEBPACK FOOTER //
// ./src/auth/authWithOtp/constants2.js